// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductBasketItems_list__RPmch","listItem":"ProductBasketItems_listItem__AlEYo","text":"ProductBasketItems_text__My_YM"};